import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { ShieldOutlined as ShieldIcon } from '@mui/icons-material';

/**
 * Header component for ManageKeywords page
 *
 * @param {Object} props Component props
 * @param {number} props.keywordCount The total number of keywords
 * @returns {JSX.Element} Rendered header component
 */
const KeywordHeader = ({ keywordCount }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: 'error.light',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 2,
          opacity: 1,
        }}
      >
        <ShieldIcon
          sx={{
            fontSize: 23,
            color: 'error.main',
            opacity: 1,
          }}
        />
      </Box>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 500 }}>
          Blacklisted Keywords Management
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {keywordCount} keywords blocked
        </Typography>
      </Box>
    </Box>
  );
};

KeywordHeader.propTypes = {
  keywordCount: PropTypes.number.isRequired,
};

export default KeywordHeader;
